export default __webpack_public_path__ + "static/829-5ccce8c348b5f7bd78624cf429610331.gif";